var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferendaPreparing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11035_47185)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_11035_47185)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 12.375C15.7741 12.375 14.375 13.7741 14.375 15.5V19C14.375 19.3452 14.6548 19.625 15 19.625C15.3452 19.625 15.625 19.3452 15.625 19V15.5C15.625 14.4645 16.4645 13.625 17.5 13.625H24.375V16.5001C24.375 17.6737 25.3264 18.6251 26.5 18.6251H29.375V28.5C29.375 29.5355 28.5355 30.375 27.5 30.375H23C22.6548 30.375 22.375 30.6548 22.375 31C22.375 31.3452 22.6548 31.625 23 31.625H27.5C29.2259 31.625 30.625 30.2259 30.625 28.5V18.3717C30.625 17.4103 30.2431 16.4882 29.5633 15.8084L27.1916 13.4367C26.5118 12.7569 25.5897 12.375 24.6283 12.375H17.5ZM25.625 16.5001V13.8442C25.8765 13.9605 26.108 14.121 26.3077 14.3206L28.6794 16.6923C28.8791 16.892 29.0395 17.1236 29.1558 17.3751H26.5C26.0168 17.3751 25.625 16.9833 25.625 16.5001ZM12.625 26.5C12.625 24.3599 14.3599 22.625 16.5 22.625C18.6401 22.625 20.375 24.3599 20.375 26.5C20.375 28.6401 18.6401 30.375 16.5 30.375C14.3599 30.375 12.625 28.6401 12.625 26.5ZM16.5 21.375C13.6695 21.375 11.375 23.6695 11.375 26.5C11.375 29.3305 13.6695 31.625 16.5 31.625C19.3305 31.625 21.625 29.3305 21.625 26.5C21.625 23.6695 19.3305 21.375 16.5 21.375ZM17.018 24.9832C17.018 24.638 16.7382 24.3582 16.393 24.3582C16.0478 24.3582 15.768 24.638 15.768 24.9832V26.7367C15.768 26.9547 15.8815 27.1568 16.0675 27.2703L17.4497 28.1135C17.7444 28.2932 18.129 28.2001 18.3088 27.9054C18.4885 27.6107 18.3954 27.2261 18.1007 27.0463L17.018 26.3859V24.9832Z",
    fill: "#1B202C",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11035_47185",
    x1: 0,
    y1: 0,
    x2: 44,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B202C",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B202C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11035_47185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferendaPreparing);
export default __webpack_public_path__ + "static/media/referenda-preparing.4ff483d2688ed9d81a1404c12314f72b.svg";
export { ForwardRef as ReactComponent };